export default "__VITE_ASSET__cbd82638__"